<svg-icon *ngIf="!text"></svg-icon>
<!--баг, иначе верстка едет-->
<svg-icon *ngIf="!!text" class="check-status" [ngStyle]="{ cursor: text ? 'pointer' : 'auto' }" matSuffix key="buttonHistory"></svg-icon>
<div *ngIf="text" class="check-status-tooltip">
  <h4>Данные до изменений</h4>
  {{ text }}
</div>
